<div class="candidate-job-match-profile-container">
    <div class="main-box">
        <div class="row">
            <div class="col-xs-12">
                <tabset *ngIf="validTabs.length > 0; else tabsLoading">
                    <tab *ngFor="let tab of validTabs" [active]="tab.isActive"
                        (selectTab)="selectTab(tab)">
                        <ng-template tabHeading>
                            <span>{{tab.name}}</span>
                            <span class="fa fa-exclamation-circle red ml-2" tooltip-placement="top" tooltip="Complete Missing Information"
                                *ngIf="(tab.name == 'Profile') && isCandidateContactDetailsMissing"></span>
                        </ng-template>
                        <app-candidate-profile *ngIf="tab.isActive && tab.name == 'Profile'"
                            [candidateId]="candidateId" [context]="context"
                            (candidateContactDetailsMissingCallback)="isCandidateContactDetailsMissing = $event">
                        </app-candidate-profile>
                        <app-job-profile *ngIf="tab.isActive && tab.name == 'Job Profile'"
                            [jobId]="jobId" [context]="context">
                        </app-job-profile>
                        <app-candidate-job-comparison *ngIf="tab.isActive && tab.name == 'Compare'"
                            [jobId]="jobId"
                            [jobMatchId]="jobMatchId"
                            [candidateId]="candidateId">
                        </app-candidate-job-comparison>
                        <app-candidate-documents *ngIf="tab.isActive && tab.name == 'Documents'"
                            [candidateId]="candidateId"
                            [candidateType]="candidateType"
                            [candidateDetails]="candidateDetails"
                            (saveCallback)="saveCallback()"
                            (cancelCallback)="cancelCallback()"
                            [sourceScreen]="sourceScreen"
                            [formalizeActivityPayload]="formalizeActivityPayload">
                        </app-candidate-documents>
                        <div class="row" *ngIf="tab.isActive && tab.name !== 'Profile' && tab.name !== 'Additional Details' && tab.name !== 'Job Profile' && tab.name !== 'Compare' && tab.name !== 'Documents'">
                            <div class="col-xs-12">
                                <object [data]="tab.safeUrl" type="application/pdf"
                                    style="width:100%; height:500px;">
                                    <embed [src]="tab.safeUrl" type="application/pdf" width="100%" height="500px">
                                </object>
                            </div>
                        </div>
                    </tab>
                </tabset>
                <ng-template #tabsLoading>
                    <div class="candidate-job-match-profile-skeleton">
                        <div class="skeleton-tab-strip">
                            <div class="skeleton-tab skeleton-loading" *ngFor="let w of [70, 90, 80, 100]" [style.width.px]="w"></div>
                        </div>
                        <div class="skeleton-tab-strip skeleton-sub-tab-strip">
                            <div class="skeleton-tab skeleton-loading" *ngFor="let w of [70, 100, 120, 130]" [style.width.px]="w"></div>
                        </div>
                        <div class="skeleton-profile-header">
                            <div class="skeleton-heading skeleton-loading" style="width: 30%;"></div>
                            <div class="skeleton-paragraph skeleton-loading" style="width: 18%;"></div>
                            <div class="skeleton-paragraph skeleton-loading" style="width: 22%;"></div>
                            <div class="skeleton-paragraph skeleton-loading" style="width: 40%;"></div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6" *ngFor="let col of [0, 1]">
                                <div class="skeleton-heading skeleton-loading" style="width: 35%; margin-bottom: 14px;"></div>
                                <div class="skeleton-paragraph skeleton-loading" style="width: 85%; margin-bottom: 10px;"></div>
                                <div class="skeleton-paragraph skeleton-loading" style="width: 70%; margin-bottom: 10px;"></div>
                                <div class="skeleton-paragraph skeleton-loading" style="width: 80%;"></div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
